<template>
 <div class="admin-header">
    <div class="admin-header-label">МЕНЮ</div>
    <div class="menu-admin">        
        <nav>
            <a v-for="(route,index) in $router.options.routes.filter(el=>el.meta.showmenu && el.meta.admin)" :class="{active: route.path==$router.currentRoute.path}" :key="index" :href="route.path" >{{getCaption(route)}}</a>  
            <a @click="submitSignout()" class="loginout">Выход <timer></timer></a>                  
        </nav>        
    </div>    
    </div>   
</template>

<script>
import Authentication from "@/components/pages/Authentication";
import Timer from "@/components/components/Timer";
export default {
    props:['pages'],  
  methods: {
    getCaption(route){
        let alias = route.path.split("/")
        let pagecaption = this.pages.find(page => page.alias == alias[alias.length-1]) 
        return (pagecaption && pagecaption.caption) ? pagecaption.caption : route.name
    },  
    submitSignout() {
      Authentication.signout(this, "/admin");
    },
  },
  components:{
      'timer': Timer
  }
};
</script>

<style lang="scss">

.admin-header{
    position: fixed;
    width: 250px;
    height: 100vh;
    padding-bottom: 70px;
    overflow: auto;
    border-right: 1px solid #ccc;
    background-color: #f1f1f1;
    &-label{
        width:100%;
        background-color: #6c757d;
        padding: 10px;
        color: #fff;
        text-align: center;
    }
    a{
        display: block;
        padding: 10px;
        border-bottom: 1px solid #ccc;
        color:$color ;
        &.active{
            background-color: #fff;
        }
        cursor: pointer;
        &:hover{
            text-decoration: none;
            background-color: #fff;
        }
        &.loginout{
            position: fixed;
            bottom: 0;
            left: 0;
            width: 249px;
            border-top: 1px solid #ccc;
            color:#fff;
            background-color: #6c757d;
            &:hover{
                background-color: #5a6268;
            }
        }

    }
}

.admin{
    min-height: 100vh;
    background-color: #fff;
    .content{
        margin-left: 250px;
    }
}

</style>